import React from 'react';

import styled from 'styled-components';

import { getFolderContacts } from '@libs/NwFolders';

import { useAddContactsToFolder, useFolders, useRemoveContactsFromFolder } from '@hooks/API/UseFolders';

import { useContactsSelector } from '@components/ContactsSelector/Common/ContactsSelectorContext';
import { NwAddButton, NwButton } from '@components/Gui/NwButton';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0.25rem 0;
`;

/**
 * Colonna azione del selettore modelle in scope "folder": aggiunge o toglie la modella
 * dalla folder di destinazione. La folder arriva dal context come solo ID e il contenuto
 * si rilegge dalla query, cosi' la riga si aggiorna da sola dopo ogni mutation.
 */
const FolderModelsTableColumn = ({ model }) => {
    const { context } = useContactsSelector();
    const { currentFolderID } = context;

    const { data: folders } = useFolders();
    const { mutateAsync: addContactsToFolder, isLoading: isAdding } = useAddContactsToFolder();
    const { mutateAsync: removeContactsFromFolder, isLoading: isRemoving } = useRemoveContactsFromFolder();

    const folder = folders && folders.find((item) => item.ID === Number(currentFolderID));

    if (!folder) {
        return null;
    }

    const isInFolder = getFolderContacts(folder).includes(model.ID);

    const handleAdd = async () => {
        try {
            await addContactsToFolder({ folderID: folder.ID, contactIDs: [model.ID] });
        } catch (error) {
            console.error('Add Folder Contact Error => ', error);
        }
    };

    const handleRemove = async () => {
        try {
            await removeContactsFromFolder({ folderID: folder.ID, contactIDs: [model.ID] });
        } catch (error) {
            console.error('Remove Folder Contact Error => ', error);
        }
    };

    return (
        <Wrapper>
            {isInFolder ? (
                <NwButton
                    ghost
                    danger
                    icon={byPrefixAndName.fasl['user-xmark']}
                    label="remove"
                    loading={isRemoving}
                    loadingLabel="removing..."
                    onClick={handleRemove}
                />
            ) : (
                <NwAddButton primary label="add" loading={isAdding} loadingLabel="adding..." onClick={handleAdd} />
            )}
        </Wrapper>
    );
};

export default FolderModelsTableColumn;
